import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c0fbf1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum endereço adicionado ainda", -1))
const _hoisted_2 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-21" }, null, -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-4 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_apresentar_cidade = _resolveComponent("apresentar-cidade")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_endereco_pessoa_modal = _resolveComponent("endereco-pessoa-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        columns: _ctx.state.colunasGrade.filter(item => item.visible),
        "data-source": _ctx.computedEnderecosPessoa,
        rowKey: "codigo",
        pagination: false,
        scroll: { y: 100},
        size: "small"
      }, {
        emptyText: _withCtx(() => [
          _hoisted_1
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column.key === 'acoes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("a", {
                  class: "visualizar",
                  onClick: ($event: any) => (_ctx.editarEndereco(record))
                }, [
                  _createVNode(_component_icone, { nome: "editar" })
                ], 8, _hoisted_3),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                  class: "excluir"
                }, [
                  _createVNode(_component_icone, { nome: "excluir" })
                ], 8, _hoisted_4)
              ]))
            : (column.key === 'TipoEndereco')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.obterDescricaoTipoEndereco(record.tipoEndereco)), 1))
              : (column.key === 'Logradouro')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.endereco.logradouro), 1))
                : (column.key === 'Numero')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.endereco.numero), 1))
                  : (column.key === 'Complemento')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.endereco.complemento), 1))
                    : (column.key === 'Bairro')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.endereco.bairro), 1))
                      : (column.key === 'CidadeEstado')
                        ? (_openBlock(), _createBlock(_component_apresentar_cidade, {
                            key: 6,
                            codigo: record.endereco.codigoCidade
                          }, null, 8, ["codigo"]))
                        : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
          style: {"margin-top":"5px","width":"100%"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.novoEndereco && _ctx.novoEndereco(...args)))
        }, "Novo Endereço")
      ])
    ]),
    _createVNode(_component_endereco_pessoa_modal, {
      visivel: _ctx.state.exibirEnderecoModal,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirEnderecoModal) = $event)),
      endereco: _ctx.state.enderecoSelecionado,
      empresas: _ctx.props.empresas,
      relacoes: _ctx.props.relacoes,
      onSalvarEndereco: _ctx.salvarEndereco
    }, null, 8, ["visivel", "endereco", "empresas", "relacoes", "onSalvarEndereco"])
  ], 64))
}